export default {"src":"/uk/_next/static/media/piggy-bank.1c130be3.svg","height":121,"width":121,"blurWidth":0,"blurHeight":0};